import { VStack, Text, HStack, Button, Icon, chakra } from "@chakra-ui/react";
import { S3Response } from "react-s3-uploader";
import { Reorder } from "framer-motion";
import { FaPlus } from "react-icons/fa";
import CarouselItem from "./CarouselItem";

const List = chakra(Reorder.Group);

interface CarouselSectionProps {
  format: "portrait";
  label: string;
  carouselMediaType: string;
  mediaItems: any[];
  createPublicUploadUrl: (params: {
    file: File;
    callback: (params: S3Response) => void | Promise<void | string>;
  }) => Promise<S3Response & { cdn_url: string }>;
  updateMedia: (index: number, result: any) => void;
  removeMedia: (index: number) => void;
  addMedia: () => void;
  handleMouseDownReorder: (e: React.PointerEvent, item: any, dc: any) => void;
  mediaOrder: number[];
  setMediaOrder: React.Dispatch<React.SetStateAction<number[]>>;
}

const CarouselSection = ({
  format,
  label,
  carouselMediaType,
  mediaItems,
  createPublicUploadUrl,
  updateMedia,
  removeMedia,
  addMedia,
  handleMouseDownReorder,
  mediaOrder,
  setMediaOrder,
}: CarouselSectionProps) => {
  const formatOrder = mediaOrder;
  const formatItems = mediaItems;

  const handleReorder = (newOrder: number[]) => {
    setMediaOrder(newOrder);
  };

  return (
    <VStack w="full" spacing={3}>
      <HStack w="full" justifyContent="space-between">
        <Text
          fontSize="md"
          fontWeight="semibold"
          color="gray.600"
          textTransform="capitalize"
        >
          {label}
        </Text>
      </HStack>

      {formatOrder.length > 0 ? (
        <List
          axis="y"
          onReorder={handleReorder}
          values={formatOrder}
          listStyleType="none"
          draggable={false}
          gap={4}
          w="full"
        >
          {formatOrder.map((orderIndex) => {
            const item = formatItems[orderIndex];
            return (
              <CarouselItem
                key={orderIndex}
                orderIndex={orderIndex}
                item={item}
                carouselMediaType={carouselMediaType}
                format={format}
                createPublicUploadUrl={createPublicUploadUrl}
                updateMedia={updateMedia}
                removeMedia={removeMedia}
                handleMouseDownReorder={handleMouseDownReorder}
              />
            );
          })}
        </List>
      ) : null}
      <Button
        size="sm"
        variant="outline"
        onClick={addMedia}
        isDisabled={formatItems.length >= 10}
        rounded="md"
        py={4}
        fontWeight={"medium"}
        rightIcon={<Icon as={FaPlus} />}
      >
        Add Media
      </Button>
    </VStack>
  );
};

export default CarouselSection;
